import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Announcement } from '../../../../core/models/announcement.model';
import { ListingCardComponent } from '../../../../shared/components/listing-card/listing-card.component';

@Component({
  selector: 'app-similar-listings',
  standalone: true,
  imports: [CommonModule, ListingCardComponent],
  template: `
    <div class="similar-section" *ngIf="listings && listings.length > 0">
      <h2 class="section-title">Oxşar elanlar</h2>
      <div class="listings-grid">
        <app-listing-card *ngFor="let item of listings" [listing]="item"></app-listing-card>
      </div>
    </div>
  `,
  styles: [`
    .similar-section {
      padding: 32px 0;
      border-top: 1px solid #f1f2f6;
    }
    .section-title {
      font-size: 22px;
      font-weight: 700;
      margin-bottom: 24px;
      color: #2d3436;
    }
    .listings-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
      gap: 24px;
    }
  `]
})
export class SimilarListingsComponent {
  @Input() listings: Announcement[] = [];
}
